import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { IWeissmanModalComponent } from 'src/app/Compliance/WeissmanModalService';
import { PaymentBatchService } from '../../paymentBatch.service';

export interface ShippingMethodsModalParams {
    paymentBatchId: number;
}

@Component({
    selector: 'shipping-methods-modal',
    templateUrl: 'shippingMethodsModal.component.html',
    styles: [`
        .shipping-methods td {
            vertical-align: middle;
        }
    `],
    standalone: false
})


export class ShippingMethodsModalComponent implements IWeissmanModalComponent<ShippingMethodsModalParams, File>, OnInit {
    constructor(
        private readonly _bsModalRef: BsModalRef,
        private readonly _paymentBatchService: PaymentBatchService,
        private readonly _toastr: ToastrService
    ) {
    }

    params: ShippingMethodsModalParams;
    result: File;

    serverAction: boolean = false;
    shippingMethodPackages: Core.PaymentBatchDetailsShippingMethodsModel[];
    shippingMethods = [{
        id: Core.PaymentBatchShippingMethodEnum.USPSStandard,
        name: 'USPS Standard'
    }, {
        id: Core.PaymentBatchShippingMethodEnum.USPSStandardScottsdale,
        name: 'USPS Standard (Scottsdale)'
    }, {
        id: Core.PaymentBatchShippingMethodEnum.USPSCertifiedWReturnReceipt,
        name: 'USPS Certified w/Return Receipt'
    }, {
        id: Core.PaymentBatchShippingMethodEnum.USPSCertifiedWReturnReceiptScottsdale,
        name: 'USPS Certified w/Return Receipt (Scottsdale)'
    }, {
        id: Core.PaymentBatchShippingMethodEnum.USPSCertifiedWNoReturnReceipt,
        name: 'USPS Certified w/No Return Receipt '
    }, {
        id: Core.PaymentBatchShippingMethodEnum.USPSCertifiedWNoReturnReceiptScottsdale,
        name: 'USPS Certified w/No Return Receipt (Scottsdale)'
    }, {
        id: Core.PaymentBatchShippingMethodEnum.FedEx,
        name: 'FedEx'
    }
    ];

    async ngOnInit(): Promise<void> {
        this.serverAction = true;
        try {
            this.shippingMethodPackages = await this._paymentBatchService.getShippingMethods(this.params.paymentBatchId);
        } finally {
            this.serverAction = false;
        }
    }

    getIt() {
        console.log(this.shippingMethodPackages);
    }

    async save() {
        this.serverAction = true;
        try {
            await this._paymentBatchService.setShippingMethods(this.params.paymentBatchId, this.shippingMethodPackages);
            this._bsModalRef.hide();
        } finally {
            this.serverAction = false;
        }
    }

    cancel() {
        this._bsModalRef.hide();
    }

}
